import { unStructuredDataSources } from './unStructuredDataSources'
import { structuredDataSources } from './structuredDataSources'
import { pggaDataSources } from './pggaDataSources'
import { enggDataSources } from './enggDataSources'
import { ccrpDataSources } from './ccrpDataSources'
import { pghvDataSources } from './pghvDataSources'
import { digitalCoEDataSources } from './digitalCoEDataSources'
import { digitalCoreProjectManagementDataSources } from './digitalCoreProjectManagementDataSources'
import { rorDataSources } from './rorDataSources'
import { nuclearLegalDataSources } from './nuclearLegalDataSources'
import { hvProjectTrackerDataSources } from './hvProjectTrackerDataSources'
import { pmCertDataSources } from './pmCertDataSources'
import { hvdcAcademyDataSources } from './hvdcAcademyDataSources'
import { zaragozaDataSources } from './zaragozaDataSources'
import { hseIncidentDataSources } from './hseIncidentDataSources'
import { grcmDataSources } from './grcmDataSources'

export const dataSources = [
  {
    dataSource: 'General',
    AccordionItemProps: unStructuredDataSources
  },
  {
    dataSource: 'Project Data Insights',
    AccordionItemProps: structuredDataSources
  },
  {
    dataSource: 'Grid Automation',
    AccordionItemProps: pggaDataSources
  },
  {
    dataSource: 'TrafoChat',
    AccordionItemProps: enggDataSources
  },
  {
    dataSource: 'CCRP',
    AccordionItemProps: ccrpDataSources
  },
  {
    dataSource: 'Switch Insights',
    AccordionItemProps: pghvDataSources
  },
  {
    dataSource: 'Digital Core Center of Expertise',
    AccordionItemProps: digitalCoEDataSources
  },
  {
    dataSource: 'Digital Core Project Management',
    AccordionItemProps: digitalCoreProjectManagementDataSources
  },
  {
    dataSource: 'Review of Records (RoR) Platform',
    AccordionItemProps: rorDataSources
  },
  {
    dataSource: 'Nuclear Legal',
    AccordionItemProps: nuclearLegalDataSources
  },
  {
    dataSource: 'HV Project',
    AccordionItemProps: hvProjectTrackerDataSources
  },
  {
    dataSource: 'PM Certification',
    AccordionItemProps: pmCertDataSources
  },
  {
    dataSource: 'HVDC Academy',
    AccordionItemProps: hvdcAcademyDataSources
  },
  {
    dataSource: 'TR Zaragoza Engineering Process Documentation',
    AccordionItemProps: zaragozaDataSources
  },
  {
    dataSource: 'HSE Incident',
    AccordionItemProps: hseIncidentDataSources,
  },
  {
    dataSource: 'GRCM - Group Risk and Compliance Management',
    AccordionItemProps: grcmDataSources,
  }
]
